import _objectSpread from "/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.join.js";
import FormBox from '../../components/FormBox';
import { imageLoad, kfltApi } from '../../api/myApi.js';
import { diseaseTypes } from '../../utils/data.js';
import CheckBook from '../../components/CheckBook';
import dayjs from 'dayjs';
import { Toast } from 'vant';
export default {
  name: 'Home',
  components: {
    FormBox: FormBox,
    CheckBook: CheckBook
  },
  data: function data() {
    return {
      minDate: new Date(),
      // 设置为当前时间
      diseaseTypes: diseaseTypes,
      checked: false,
      data: {
        age: '',
        appointmentTime: ''
      },
      isIpt: true,
      hospitalList: [],
      showPicker: false,
      images: [],
      rules: {
        age: [{
          required: true,
          message: '请输入年龄',
          trigger: 'blur'
        }],
        diseaseType: [{
          required: true,
          message: '请选择病种',
          trigger: 'change'
        }],
        appointmentTime: [{
          required: true,
          message: '请选择预约时间',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    onConfirm: function onConfirm(time) {
      var _this = this;
      console.log(time);
      var now = dayjs(time);
      this.data.appointmentTime = now.format('YYYY-MM-DD HH:mm:ss');
      this.$nextTick(function () {
        _this.$refs.form.validateField('appointmentTime'); // 手动触发验证
        _this.showPicker = false;
      });
    },
    inspectBtn: function inspectBtn(topData, isD) {
      this.isIpt = isD;
      this.data = _objectSpread(_objectSpread({}, this.data), topData);
    },
    onSubmit: function onSubmit(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          kfltApi(_objectSpread(_objectSpread({}, _this2.data), {}, {
            serviceType: '2',
            diseaseType: _this2.data.diseaseType.join('/')
          })).then(function (res) {
            Toast.success(res.msg);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};